/** PO can no longer be archived after status was set to under_review once. */
export function isPoArchiveDisabled(archiveDisabled: boolean | null | undefined): boolean {
  return archiveDisabled === true;
}

export function getPoArchiveDisabledMessage(): string {
  return 'Cannot archive: this purchase order has been under admin review';
}
